module.exports = __webpack_public_path__ + "img/news7.647f7d7a.jpg";